/* eslint-disable */

import StoreClient from "../Client";
import axios from "axios";
import { setting } from "../setting";

export const FETCH_ACTION = "identity.FETCH";
export const RECEIVE_ACTION = "identity.RECEIVE";
export const ERROR_ACTION = "identity.ERROR";
export const AUTH_ERROR_ACTION = "identity.AUTH_ERROR";

const checkRoleInclude = role =>
  role.includes("ADMIN") ||
  role.includes("OFFICE") ||
  role.includes("EDITOR") ||
  role.includes("VIEWER") ||
  role.includes("MOBILE");

export const fetchAction = () => dispatch =>
  dispatch({
    type: FETCH_ACTION,
  });

export const receive = (state, data) => {
  console.log(data);

  // this.$store.commit({
  //   type: types.SET_USER_DATA,
  //   ...data
  // });
}

// export const error = message => dispatch =>
//   dispatch({
//     type: ERROR_ACTION,
//     message
//   });

// export const authError = message => dispatch =>
//   dispatch({
//     type: AUTH_ERROR_ACTION,
//     message
//   });

const GET_IDENTITY = /* GraphQL */ `
  {
    identity: me {
      id
      username
      email
      createdAt
      status
      role
      profile {
        id
        name
        image
        card
      }
      employeeInfo {
        id
        phones
        theatre {
          id
          originalId
          city {
            id
          }
        }
      }
    }
  }
`;

export const fetchData = authKey => {
  // dispatch(fetchAction());
  console.log('authKey', authKey);

  return axios({
    url: setting.authHost + '/identity?withProfile=true',
    withCredentials: true,
  }).then(response => {
    return response.data;
  }).catch(e => console.log(e));

  return StoreClient.setHeader("authKey", authKey)
    .request(GET_IDENTITY)
    .then(res => {

      const { identity } = res;
      if (!identity) {
        console.log('error: Unauthorized');

        // return authError("Unauthorized");
      }
      // if (!(identity.role && checkRoleInclude(identity.role))) {
      //   console.log('error: Forbitten');

      //   // return authError("Forbitten");
      // }
      // console.log('identity:', identity);


      return identity;
    })
    .catch(e => console.log(e))
  // .then(dispatch);
};
